import 'jquery';

export class PopupCloseHeader {
  public static addToContentElement(content: HTMLElement, closeFunc: () => void): HTMLElement {
    const $header = jQuery('<div class="popup-close-header"></div>');
    const $closeButton = jQuery(
      '<a class="leaflet-popup-close-button" href="javascript:void(0)" style="outline: none;">×</a>',
    )[0];
    $closeButton.addEventListener('click', () => closeFunc());

    $header.append($closeButton);

    jQuery(content).prepend($header);
    return content;
  }
}
